<dialog-header [label]="'MENUBAR.VIDEO_PLAYER_TITLE' | translate: {videoTitle: videoTitle}" [dialogRef]='dialogRef' (mousedown)="windowClick()" [object]='this'></dialog-header>
<vg-player style="width: 100%" [style.height.px]="playerHeight" [style.width]="playerWidth">
  <vg-overlay-play></vg-overlay-play>
  <vg-scrub-bar>
    <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
  </vg-scrub-bar>
  <vg-controls [vgAutohide]="true">
    <vg-play-pause></vg-play-pause>
    <vg-playback-button [playbackValues]="['0.25', '0.5', '1.0', '2.0', '4.0', '8.0']"></vg-playback-button>
    <vg-time-display vgProperty="current"></vg-time-display>
    <vg-scrub-bar style="pointer-events: none"></vg-scrub-bar>
    <vg-time-display vgProperty="left"></vg-time-display>
    <vg-time-display vgProperty="total"></vg-time-display>
    <vg-mute></vg-mute>
    <vg-volume></vg-volume>
    <vg-fullscreen></vg-fullscreen>
  </vg-controls>
  <video style="width: 100%" [vgMedia]="media" #media id="videoPlayer" preload="auto" src="{{videoSrc}}" loop></video>
</vg-player>
<div class="status-bar"></div>
